import styled from 'styled-components';
import { string } from 'prop-types';
import { Container } from 'styles';
import { Text as ShrikeText } from '@perch-labs/shrike';
import {
  color,
  flexbox,
  layout,
  space,
  typography,
  ColorProps,
  FlexboxProps,
  LayoutProps,
  SpaceProps,
  TypographyProps,
} from 'styled-system';
import { getPropTypes } from '../../styles/utils';

interface TitleAndDescriptionProps
  extends ColorProps,
    SpaceProps,
    TypographyProps {
  margin?: string;
  fontSize?: string;
}
interface TextProps
  extends TitleAndDescriptionProps,
    FlexboxProps,
    LayoutProps {}

export const Title = styled(ShrikeText).attrs({
  tag: 'h1',
  textStyle: 'heading800',
})<TitleAndDescriptionProps>`
  margin: ${props => props.margin || '40px 0 16px'};
  fontsize: ${props => props.fontSize};
  ${color}
  ${space}
  ${typography}

  @media ${props => props.theme.media.tabletLandscapeDown} {
    ${props => !props.margin && 'margin-top: 0;'}
  }
`;

export const Description = styled(ShrikeText)<TitleAndDescriptionProps>`
  margin-bottom: 24px;
  ${color}
  ${space}
  ${typography}
`;

export const Text = styled(ShrikeText)<TextProps>`
  ${flexbox}
  ${layout}
  ${space}
  ${typography}
`;

export const Ul = styled.ul<SpaceProps>`
  list-style: disc outside;
  margin-left: 20px;
  ${space}

  li {
    line-height: 150%;
  }
`;

export const StyledUl = styled(Ul)`
  margin-left: 0px;

  li {
    align-items: flex-start;
    display: flex;
  }

  li:not(:first-child):not(:last-child) {
    margin: 16px 0;
  }
`;

export const UlListItem = styled.li<SpaceProps>`
  ${space}
`;

export const UlListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  align-items: center;
`;

export const PerchContainer = styled(Container)<StyleProps>`
  max-width: 540px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const PerchPageCt = styled(Container).attrs({
  padding: '24px 24px 48px',
})<StyleProps>`
  padding: 0;
  img {
    text-align: center;
  }
  h1 {
    text-align: center;
    margin: 16px 0 32px;
  }
  .overline {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    letter-spacing: 1px;
    text-align: center;
    text-transform: uppercase;
    padding-bottom: 16px;
  }
  .ul-item {
    .bold {
      font-weight: 700;
    }
    svg {
      path {
        fill: #00a980;
      }
    }
    li:last-child {
      padding-top: 16px;
    }
  }
  button {
    margin-top: 32px;
    width: 328px;
    background: #15e399;
    color: #0d2727;
    border-radius: 8px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    line-height: 1;
    padding: 11px 16px;
    text-align: center;
    text-decoration: none;
    transition: 0.1s;
    white-space: normal;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    border: none;
    height: 40px;
    font-weight: 800;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0px;
    &:hover,
    &:visited,
    &:active {
      background: #15e399;
      color: #0d2727;
    }
  }
`;

export const pageProps = {
  maxWidth: string,
};

PerchPageCt.propTypes = getPropTypes(pageProps);
